import {colors} from '@/constants/theme/colors'

export const userGuideStyles = {
    options: {
        arrowColor: colors.blue1,
        backgroundColor: colors.primary800,
        overlayColor: 'rgba(79, 26, 0, 0)',
        primaryColor: colors.white,
        textColor: colors.white,
        width: 500,
        zIndex: 1000
    },
    buttonNext: {
        background: 'none'
    },
    buttonSkip: {
        border: `1px solid ${colors.white}`,
        borderRadius: 8,
        fontSize: 14
    },
    tooltipTitle: {
        fontSize: 18,
        margin: '0 0 10px 0',
        color: colors.white
    },
    buttonBack: {
        display: 'none'
    }
}
